import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Empty } from "@/components/PageHeader";
import { money } from "@/lib/format";

export const FilingsTab = ({ period, filings, arn, setArn, onFile }) => (
  <div className="space-y-4" data-testid="filings-view">
    <div className="flex flex-wrap items-center gap-2 border border-border p-3">
      <p className="text-xs text-muted-foreground">
        Log a return as filed for {period}. ARN is recorded as-is; leave it blank to store a simulated ARN — no live GSTN submission happens.
      </p>
      <div className="ml-auto flex items-center gap-2">
        <Input className="h-8 w-44 text-xs" placeholder="ARN (optional)" value={arn}
          onChange={(e) => setArn(e.target.value)} data-testid="filing-arn-input" />
        <Button size="sm" variant="outline" onClick={() => onFile("GSTR-1")} data-testid="file-gstr1-btn">File GSTR-1</Button>
        <Button size="sm" variant="outline" onClick={() => onFile("GSTR-3B")} data-testid="file-gstr3b-btn">File GSTR-3B</Button>
      </div>
    </div>
    {filings.length === 0 ? (
      <Empty label="Nothing filed yet" hint="Export the JSON, upload it to the offline utility, then log the ARN here." />
    ) : (
      <div className="overflow-x-auto border border-border">
        <table className="dense-table w-full min-w-[820px]" data-testid="filings-table">
          <thead><tr><th>Return</th><th>Period</th><th>ARN</th><th>Docs</th>
            <th className="text-right">Taxable</th><th>Filed by</th><th>Filed at</th><th>Payload hash</th></tr></thead>
          <tbody>
            {filings.map((f) => (
              <tr key={f.id} className="row-in" data-testid={`filing-row-${f.id}`}>
                <td className="font-medium">{f.return_type}</td>
                <td className="num">{f.period}</td>
                <td className="num">
                  {f.arn}{f.simulated ? <span className="ml-1 text-[10px] uppercase text-muted-foreground">sim</span> : null}
                </td>
                <td className="num">{f.doc_count}</td>
                <td className="num text-right">{money(f.totals?.taxable)}</td>
                <td>{f.filed_by_name || "—"}</td>
                <td className="num whitespace-nowrap text-[11px] text-muted-foreground">
                  {new Date(f.filed_at).toLocaleString("en-IN")}
                </td>
                <td className="num text-[10px] text-muted-foreground">{(f.payload_hash || "").slice(0, 12)}…</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )}
  </div>
);
